export const CardPriceBlock = ({ children }) => {
    return <div className="price-block">{children}</div>;
};
